import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import React from "react";
import FeatherIcon from "feather-icons-react";
// import { breadCrumbs } from "../version-list/model/version-list.constants";
import { breadCrumbs } from "../inventory-category-list/model/category-list.constants";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";
import CardComponent from "@atoms/card/card.component";

const ActionContent = ({ handleSaveClick, handleBackClick }) => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleSaveClick}
      >
        <FeatherIcon icon="save" size={17} />
      </button>

      <button
        type="button"
        className="btn btn-outline-primary btn-sm ml-2"
        onClick={handleBackClick}
      >
        <FeatherIcon icon="arrow-left" size={17} />
      </button>
    </>
  );
};

const InventoryCategoryEditTemplateComponent = ({
  templateModal: { formTriggers, formInputs },
  templateEvents: { handleSubmit, handleTriggerClick, handleBackClick },
}) => {
  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Edit Category"}
        breadCrumbs={[
          ...breadCrumbs,
          { name: "Edit ", menu_url: "/inventory/category/edit" },
        ]}
        actionContent={
          <ActionContent
            handleSaveClick={() => handleTriggerClick("SUBMIT")}
            handleBackClick={handleBackClick}
          />
        }
      />

      {/* <CardComponent> */}
        <FormBuilderComponent
          formType={"group"}
          inputFields={formInputs}
          submitTrigger={formTriggers.submitTrigger}
          onSubmit={handleSubmit}
        />
      {/* </CardComponent> */}
    </PageWrapperComponent>
  );
};

export default InventoryCategoryEditTemplateComponent;
